import { searchJobs, tagCandidatesToJob } from '../../../../services/popupApi';
import { getHiringStageOptions } from '../../../../services/workflowApi';

export const api = {
  searchOptions: async (field, search) => {
    if (field.searchFetchKey === 'tagToJobJobList') return searchJobs(search);
    return [];
  },
  getOptions: async (field) => {
    if (field.fetchOptionsKey === 'hiringStages') return getHiringStageOptions();
    return [];
  },
  submit: async (values, context) => {
    await tagCandidatesToJob({
      jobId: values.jobId,
      candidateIds: context.selectedIds,
      hiringStage: values.hiringStage,
    });
  },
};
